<template>
    <div class="animated fadeIn">
        <spinner v-if="loading"/>
        <b-row>
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong>Search SR Usage</strong>
                    </div>
                    <b-row>
                        <b-col sm="2">
                            <label>Doc. No</label>
                            <b-form-group>
                                <b-form-input type="text" v-model="filter.doc_num"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="2">
                            <b-form-group>
                                <label>From Doc. Date</label>
                                <b-form-input type="date" v-model="filter.from_doc_date"></b-form-input>
                            </b-form-group>
                        </b-col>
                      <b-col sm="2">
                        <b-form-group>
                          <label>To Doc. Date</label>
                          <b-form-input type="date" v-model="filter.to_doc_date"></b-form-input>
                        </b-form-group>
                      </b-col>
                        <b-col sm="3">
                            <label for="country_id">Location</label>
                            <warehouseLookup v-bind:url="apiWarehouseLookup" v-on:selected="setWarehouse($event)" :lookupId="filter.location_id" :q2="filter.country_id"/>
                        </b-col>
                        <b-col sm="3">
                            <b-form-group>
                                <label>SRF No</label>
                                <b-form-input type="text" v-model="filter.srf_num"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <div slot="footer">
                        <b-button type="submit" size="lg" variant="primary" @click="search">Search</b-button>
                    </div>
                </b-card>
            </b-col>
        </b-row>
        <b-row v-if="searchResults.length >0 && !loading">
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong>SR Usage Listings</strong>
                    </div>
                    <b-row>
                        <b-col sm="12">
                            <div class="table-responsive">
                                <b-table class="table-hover" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :fields="searchResultsFields" :items="searchResults"></b-table>
                            </div>
                            <nav>
                                <b-pagination :total-rows="getRowCount(searchResults)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
                            </nav>
                        </b-col>
                    </b-row>
                    <div slot="footer">
                        <exportExcel class   = "btn btn-primary btn-lg" size ="lg" :data = "searchResults" :fields = "exportHeaders" name = "back_orders.xls">
                            Export to Excel
                        </exportExcel>
                        &nbsp;&nbsp;
<!--                        <b-button type="submit" size="lg" variant="success" @click="print">Print</b-button>-->
                    </div>
                </b-card>
            </b-col>
        </b-row>
        <b-row v-else-if="noResults && !loading" >
                <b-col sm="12">
                  <div align="center">
                    <strong>No Records Found</strong>
                  </div>
                </b-col>
        </b-row>
    </div>
</template>
<script>
import axios from 'axios'
import spinner from '@/components/Spinner.vue'
import countryLookup from '@/components/Autocomplete.vue'
import warehouseLookup from '@/components/Autocomplete.vue'
import {authHeader, apiCountryLookup,apiWarehouseLookup,apiPodUpdate,apiPodSearch,apiBackOrdersSearch, apiSrUsageListingReport} from '@/functions/common.vue'

 import pdfMake from "pdfmake/build/pdfmake";
  import pdfFonts from "pdfmake/build/vfs_fonts";
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  pdfMake.fonts = {
      "ukai": {
        normal: 'ukai.ttf',
        bold: 'ukai.ttf',
        italics: 'ukai.ttf',
        bolditalics: 'ukai.ttf'
      },
   };

import exportExcel from 'vue-json-excel'

export default
{
    components:{spinner,countryLookup,warehouseLookup,exportExcel},
    props:
    {
      caption:
      {
        type: String,
        default: 'Table'
      },
      hover:
      {
        type: Boolean,
        default: false
      },
      striped:
      {
        type: Boolean,
        default: false
      },
      bordered:
      {
        type: Boolean,
        default: false
      },
      small:
      {
        type: Boolean,
        default: false
      },
      fixed:
      {
        type: Boolean,
        default: false
      }
    },
    data()
    {
        return{
            loading: false,
            apiCountryLookup: apiCountryLookup,
            apiWarehouseLookup: apiWarehouseLookup,
            filter:
            {
                srf_num: '',
                location_id:'',
                doc_num:'',
                from_doc_date: '',
                to_doc_date: ''
            },
            exportHeaders:
            {
              'Staff ID':'staff_id',
              'Staff Name': 'staff_name',
              'Doc Date': 'doc_date',
              'Doc #':'doc_num',
              'SRF #':'srf_num',
              'Location ID':'location_id',
              'Event Start Date':'event_start_date',
              'Event End Date':'event_end_date',
              'Returnable Type':'returning_type',
              'Trans Type':'reason',
              'Reference No':'reference_num',
              'SKU':'product_code',
              'Product Name':'product_name',
              'Unit Price':'unit_price',
              'SRF Qty':'srf_qty',
              'SRR Qty':'srr_qty',
              'Usage Qty':'usage_qty',
              'Total':'usage_total_amount',
              'Remarks':'remarks'
            },
            searchResults: [],
            searchResultsFields:
            [
                {key: 'staff_id', label: 'Staff ID'},
                {key: 'staff_name', label: 'Staff Name'},
                {key: 'doc_date', label: 'Doc. Date'},
                {key: 'doc_num', label: 'Doc. No'},
                {key: 'srf_num', label: 'SRF No'},
                {key: 'location_id', label: 'Location ID'},
                {key: 'event_start_date', label: 'Event Start Date'},
                {key: 'event_end_date', label: 'Event End Date'},
                {key: 'returning_type', label: 'Returnable Type'},
                {key: 'reason', label: 'Trans Type'},
                {key: 'reference_num', label: 'Reference No'},
                {key: 'product_code', label: 'SKU'},
                {key: 'product_name', label: 'Product Name'},
                {key: 'unit_price', label: 'Unit Price'},
                {key: 'srf_qty', label: 'SRF Qty'},
                {key: 'srr_qty', label: 'SRR Qty'},
                {key: 'usage_qty', label: 'Usage Qty'},
                {key: 'usage_total_amount', label: 'Total'},
                {key: 'remarks', label: 'Remarks'}
            ],
            currentPage: 1,
            perPage: 30,
            totalRows: 0,
            noResults: false
            }
    },
    methods:
    {
        print()
        {
          var rows = []
          var row = []
          var date = new Date()
          rows.push([
          'Staff ID',
          'Staff Name',
          'Doc Date',
          'Doc No',
          'SRF No',
          'Location ID',
          'Event Start Date',
          'Event End Date',
          'Returnable Type',
          'Trans Type',
          'Reference No',
          'SKU',
          'Product Name',
          'Unit Price',
          'SRF Qty',
          'SRR Qty',
          'Usage Qty',
          'Total',
          'Remarks'
          ])

          for (let key in this.searchResults)
          {
            var data = this.searchResults[key]
            row = [
                data.staff_id,
                data.staff_name,
                data.doc_date,
                data.doc_num,
                data.srf_num,
                data.location_id,
                data.event_start_date,
                data.event_end_date,
                data.returning_type,
                data.reason,
                data.reference_num,
                data.product_code,
                data.product_name,
                data.unit_price,
                data.srf_qty,
                data.srr_qty,
                data.usage_qty,
                data.usage_total_amount,
                data.remarks
            ]
            rows.push(row)
          }
          var dd = {
            header:{ text: 'SR Usage Listings Report generated on'+ " "+ date, margin: [ 5, 7, 10, 30 ],alignment: 'center',fontSize:7 },
            pageSize: 'A4',
            pageOrientation: 'landscape',

            pageMargins: [30, 20, 30, 20 ],
            defaultStyle: {
            font: 'ukai'
          },
            content: [
              {
                fontSize: 8,
                layout: 'lightHorizontalLines', // optional
                table: {
                  // headers are automatically repeated if the table spans over multiple pages
                  // you can declare how many rows should be treated as headers
                  headerRows: 1,
                  widths: [
                    'auto',
                    'auto',
                    'auto',
                    'auto',
                    'auto',
                    'auto',
                    'auto',
                    'auto',
                    'auto',
                    'auto',
                    'auto',
                    'auto',
                    'auto',
                    'auto',
                    'auto',
                    'auto',
                    'auto',
                    'auto',
                    'auto'
                  ],
                  body: rows
                }
              }
            ]
          };

          pdfMake.createPdf(dd).open();
        },
        search()
        {
            this.loading = true
            this.submitted =true
            this.seen =true
            var sf =
            [
                "doc_num LIKE " + this.filter.doc_num
                ,"doc_date >= " + this.filter.from_doc_date
                ,"doc_date <= " + this.filter.to_doc_date
                ,"location_id = " + this.filter.location_id
                ,"srf_num = " + this.filter.srf_num
            ]
              axios.post(apiSrUsageListingReport, sf,authHeader())
                .then (res =>
                {
                  return res

                })
                .then (data =>
                {
                  const resultArray = []
                  const myData = data.data.data

                  for (let key in myData)
                  {
                    let docDate = myData[key].doc_date;
                    if (docDate != null) {
                      docDate = new Date(docDate);
                      myData[key].doc_date = "" + (docDate.getDate() > 9 ? '' : '0') + docDate.getDate() + '/'+  ((docDate.getMonth() + 1) > 9 ? '' : '0') + (docDate.getMonth() + 1) + '/' + docDate.getFullYear()
                    } else {
                      myData[key].doc_date = ""
                    }

                    let eventStartDate = myData[key].event_start_date;
                    if (eventStartDate != null) {
                      eventStartDate = new Date(eventStartDate);
                      myData[key].event_start_date = "" + (eventStartDate.getDate() > 9 ? '' : '0') + eventStartDate.getDate() + '/'+  ((eventStartDate.getMonth() + 1) > 9 ? '' : '0') + (eventStartDate.getMonth() + 1) + '/' + eventStartDate.getFullYear()
                    } else {
                      myData[key].event_start_date = ""
                    }

                    let eventEndDate = myData[key].event_end_date;
                    if (eventEndDate != null) {
                      eventEndDate = new Date(eventEndDate);
                      myData[key].event_end_date = "" + (eventEndDate.getDate() > 9 ? '' : '0') + eventEndDate.getDate() + '/'+  ((eventEndDate.getMonth() + 1) > 9 ? '' : '0') + (eventEndDate.getMonth() + 1) + '/' + eventEndDate.getFullYear()
                    } else {
                      myData[key].event_end_date = ""
                    }

                    var srf_qty = myData[key].srf_qty
                    myData[key].srf_qty = srf_qty.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")

                    var srr_qty = myData[key].srr_qty
                    myData[key].srr_qty = srr_qty.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")

                    var usage_qty = myData[key].usage_qty
                    myData[key].usage_qty = usage_qty.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")

                    resultArray.push(myData[key])
                    this.loading = false
                  }

                  this.searchResults = myData
                  if(this.searchResults.length ==0)
                  {
                    this.loading = false
                    this.noResults =true
                  }
                })
                .catch(error => console.log(error))
        },
        setWarehouse(obj)
        {
            var id

                if (obj !== null)
                {
                    id = obj.id
                }
                else
                {
                    id = ""
                }
            this.filter.location_id = id
        },
        getRowCount (items)
        {
            return items.length
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/views/reports/sr_usage.vue